<div class="logo">
  <!-- <a class="simple-text logo-mini">
    <div class="logo-img">
      <img src="/assets/img/angular2-logo-white.png" />
    </div>
  </a>
  <a href="http://consultech.rs" class="simple-text logo-normal">
    LogiMaps
  </a> -->
  <img src="./assets/img/e-box-logo-horizontal.png" style="width: 100%;" />
</div>


<div class="sidebar-wrapper">

  <div class="user">
    <div class="photo">
      <img src="./assets/img/faces/avatar.jpg" />
    </div>
    <div class="user-info">
      <a data-toggle="collapse" href="#collapseExample" class="collapsed">
        <span>
          {{user.firstName}} {{user.lastName}}
          <b class="caret"></b>
        </span>
      </a>
      <div class="collapse" id="collapseExample">
        <ul class="nav">
          <li class="nav-item">
            <a [routerLink]="['/users/',user.id]" routerLinkActive="router-link-active" class="nav-link">
              <span class="sidebar-mini"><i class="material-icons">face</i></span>
              <span class="sidebar-normal">Izmeni profil</span>
            </a>
          </li>
          <li class="nav-item">
            <a (click)="logout()" [routerLink]="['/login']" routerLinkActive="router-link-active" class="nav-link">
              <span class="sidebar-mini"><i class="material-icons">logout</i></span>
              <span class="sidebar-normal">Logout</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div *ngIf="isMobileMenu()">
    <!-- <form class="navbar-form">
      <span class="bmd-form-group">
        <div class="input-group no-border">
          <input type="text" value="" class="form-control" placeholder="Search...">
          <button mat-raised-button type="submit" class="btn btn-white btn-round btn-just-icon">
            <i class="material-icons">search</i>
            <div class="ripple-container"></div>
          </button>
        </div>
      </span>
    </form>
    <ul class="nav navbar-nav nav-mobile-menu">
      <li class="nav-item">
        <a class="nav-link" href="#pablo">
          <i class="material-icons">dashboard</i>
          <p>
            <span class="d-lg-none d-md-block">Stats</span>
          </p>
        </a>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link" href="#pablo" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          <i class="material-icons">notifications</i>
          <span class="notification">5</span>
          <p>
            <span class="d-lg-none d-md-block">Some Actions</span>
          </p>
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
          <a class="dropdown-item" href="#">Mike John responded to your email</a>
          <a class="dropdown-item" href="#">You have 5 new tasks</a>
          <a class="dropdown-item" href="#">You're now friend with Andrew</a>
          <a class="dropdown-item" href="#">Another Notification</a>
          <a class="dropdown-item" href="#">Another One</a>
        </div>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#pablo">
          <i class="material-icons">person</i>
          <p>
            <span class="d-lg-none d-md-block">Account</span>
          </p>
        </a>
      </li>
    </ul> -->
  </div>
  <div class="nav-wrapper" *ngIf="user.role == 0">
    <ul class="nav" *ngFor="let menuItem of menuItems.slice(0, -1)" >
      <div style="display: flex;" class="item-wrapper">
        <div style="width: 100%;">
          <span class="menuItemTitle pl-3 pt-1">{{ menuItem.title | uppercase}}</span>
          <li  routerLinkActive="active" class="nav-item">
            <!--If is a single link-->
            <!-- *ngIf="link.type === 'link'" -->
            <a [routerLink]="[menuItem.routeInfos[0].path]" class="nav-link" style="display: flex; gap: 30px; align-items: center;" (click)="sendLinkInfo(menuItem)">
                <span class="finance-dropdown-icon" style="padding-left: 15px;">
                  <img [src]='menuItem.routeInfos[0].icontype'>
                </span>
              <p>{{ menuItem.routeInfos[0].title }}</p>
            </a>
          

          <!--If it have a submenu-->
          <!-- <a data-toggle="collapse" href="#{{menuitem.collapse}}" *ngIf="menuitem.type === 'sub'" (click)="updatePS()"
          class="nav-link">
          <i class="material-icons">{{menuitem.icontype}}</i>
          <p>{{menuitem.title}}<b class="caret"></b></p>
        </a> -->

          <!--Display the submenu items-->
          <!-- <div id="{{menuitem.collapse}}" class="collapse" *ngIf="menuitem.type === 'sub'">
          <ul class="nav">
            <li routerLinkActive="active" *ngFor="let childitem of menuitem.children" class="nav-item">
              <a [routerLink]="[menuitem.path, childitem.path]" class="nav-link">
                <span class="sidebar-mini">{{childitem.ab}}</span>
                <span class="sidebar-normal">{{childitem.title}}</span>
              </a>
            </li>
          </ul>
        </div> -->
          </li>
        </div>
        <div *ngIf=" menuItem.title === 'Goriva'" style="width: 100%">
          <span class="menuItemTitle pl-3 pt-1">{{ menuItems[6].title | uppercase}}</span>
          <li  routerLinkActive="active" class="nav-item">
            <!--If is a single link-->
            <!-- *ngIf="link.type === 'link'" -->
            <a [routerLink]="[menuItems[6].routeInfos[0].path]" class="nav-link navlink-gas"  (click)="sendLinkInfo(menuItem)">
                <span class="finance-dropdown-icon" style="padding-left: 15px;">
                  <img [src]='menuItems[6].routeInfos[0].icontype'>
                </span>
              <p>{{ menuItems[6].title }}</p>
            </a>
          </li>
        </div>
      </div>
      <li class="nav-item">
      </li>
    </ul>
  </div>

</div>